import { AuthPageWrapper, CreateAccountForm, GuestGuard } from '@auth';

export default function SignUp() {
  return (
    <AuthPageWrapper pageTitle="Sign Up">
      <GuestGuard>
        <CreateAccountForm />
      </GuestGuard>
    </AuthPageWrapper>
  );
}
